import React, { useState, useEffect, useContext } from "react";
import Utils from "../../../../../Utils";
import ContextComponent from "../../../../../AppContext";
import DataTable from "../../../../../controls/table/DataTable";
import EmptyPage from "../../../../../pages/EmptyPage";

const IncompleteReport = ({ props }) => {
  const { setCanRedirectToLogin } = useContext(ContextComponent);

  const [tableData, setTableData] = useState([]);
  const [canRender, setCanRender] = useState(false);
  const siteId = props?.siteId;
  const tableColumns = props?.tableColumns;
  const tableColumnSchema = props?.tableColumnSchema;
  const onSiteNameUpdate = props?.onSiteNameUpdate;
  const setLoadingState = props?.setLoadingState || (() => {});

  const success = (res) => {
    setLoadingState({ applyMask: false });

    if (!res.data || res.data.length === 0) {
      setCanRender(false);
    } else {
      const reportsArray = res.data.map((item) =>
        tableColumns.map((col) => (col === "select" ? false : item[col]))
      );
      setTableData(reportsArray);
      setCanRender(true);
    }

    if (res.data[0]?.site && onSiteNameUpdate) {
      onSiteNameUpdate(`(${res.data[0].site})`);
    }
  };

  const fail = (err) => {
    setLoadingState({ applyMask: false });
    if (err?.redirect) setCanRedirectToLogin(true);
    console.error("Error fetching reports:", err);
  };

  const loadFreshIncompleteReports = (currSiteId) => {
    setLoadingState({ applyMask: true, text: "Loading reports" });
    Utils.getIncompleteReportsBySiteId({ siteId: currSiteId }).then(
      success,
      fail
    );
  };

  useEffect(() => {
    if (siteId) {
      loadFreshIncompleteReports(siteId);
    }
  }, [siteId]);

  return canRender ? (
    tableData.length > 0 && (
      <DataTable
        minRows={0}
        tableProps={{ tableColumns, tableColumnSchema, tableData }}
      />
    )
  ) : (
    <EmptyPage
      props={{ emptyMessage: "No Incomplete Reports are available" }}
    />
  );
};

export default IncompleteReport;
